export interface PanelGeom { x: number; y: number; w: number; h: number }

export const GEOM_KEY = 'bo-collaborate-panel-v2';

export function clampGeom(geom: PanelGeom): PanelGeom {
  const minW = 640;
  const minH = 380;
  const maxW = Math.max(minW, window.innerWidth - 16);
  const maxH = Math.max(minH, window.innerHeight - 16);
  const w = Math.min(Math.max(Math.round(geom.w), minW), maxW);
  const h = Math.min(Math.max(Math.round(geom.h), minH), maxH);
  const x = Math.min(Math.max(8, Math.round(geom.x)), Math.max(8, window.innerWidth - w - 8));
  const y = Math.min(Math.max(8, Math.round(geom.y)), Math.max(8, window.innerHeight - h - 8));
  return { x, y, w, h };
}

export function defaultGeom(): PanelGeom {
  const w = Math.round(window.innerWidth * 0.94);
  const h = Math.round(window.innerHeight * 0.92);
  return clampGeom({ x: Math.round((window.innerWidth - w) / 2), y: Math.round((window.innerHeight - h) / 2), w, h });
}

export function loadGeom(): PanelGeom {
  try {
    const raw = localStorage.getItem(GEOM_KEY);
    if (!raw) return defaultGeom();
    const parsed = JSON.parse(raw) as PanelGeom;
    if (![parsed.x, parsed.y, parsed.w, parsed.h].every((n) => Number.isFinite(n))) return defaultGeom();
    return clampGeom(parsed);
  } catch {
    return defaultGeom();
  }
}
